
export const addMessageListener = (callback: (event: MessageEvent) => void) => {

	window.addEventListener('message', (event) => {

		if (event.data.type !== 'agility.legacycustomfield') return
		callback(event)
	})
}